// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"759":"669a6d18","785":"c96d7a81"}[chunkId] + ".chunk.css";
};